<span class="font-500 font-s" [ngClass]="loading ? 'color-transparent loading-animate width-min-content' : 'color-title-grey'">Kommentar:</span>
<div class="am-flex-column gap-m relative color-secondary-grey internal-comment">
  <textarea id="internal-comment" cols="30" rows="3" maxlength="255" placeholder="{{ loading ? '' : readOnly ? '-' : 'Kommentar hier eingeben' }}"
            class="resize-none"
           [ngClass]="loading ? 'color-transparent loading-animate' : ''"
           [(ngModel)]="boxValue"
           (blur)="updateValue($event)"
           [disabled]="readOnly || !!value && !editMode && !hideButtons">
  </textarea>
  @if ((!!value || !!boxValue && hideButtons) && !readOnly && !editMode) { <span class="absolute right-20 color-blue text-l icon-edit" (click)="enableEditMode()"></span> }
  @if (loading) { <span class="width-120 height-36 loading-animate mla"></span> }
  @else {
    @if (!hideButtons) {
      <div class="am-flex-justify gap-m">
        @if (editMode                         ) { <button [ngClass]="buttonClass ? buttonClass : 'short-btn'" class="grey"     (click)="closeEditMode()">Abbrechen</button> }
        @if (!readOnly && (!value || editMode)) { <button [ngClass]="buttonClass ? buttonClass : 'short-btn'" class="blue mla" (click)="saveComment()">Speichern</button>   }
      </div>
    }
  }
</div>
